import { FullConfigurationResponse, GroupedEntries } from '../../../api'
import Prices from '../../../entities/Prices'
import RenderImage from '../../../entities/RenderImage'
import { useCurrentConfigurationFromVehicleCode } from './useCurrentConfigurationFromVehicleCode'

const mapPrices = (data: FullConfigurationResponse) => {
    const modelPrice = data?.model?.price
    const totalPrice = data?.prices?.total?.value

    return [
        ...(modelPrice ? [{ id: 'MODEL', value: modelPrice }] : []),
        ...(totalPrice ? [{ id: 'TOTAL', value: totalPrice, isGroupedItem: true }] : []),
    ] as Prices
}

const mapImages = (images): RenderImage[] =>
    images.map(({ id, url }) => ({
        id,
        renderDetails: [100,400,900,3840].map(size => ({size, url})),
    })) as RenderImage[]

export const useMappedConfiguration = () => {
    const { data, isLoading } = useCurrentConfigurationFromVehicleCode()

    const standardsHeadline = data?.metadata?.texts.pageStandardHeadline ?? ''
    const optionsHeadline = data?.metadata?.texts.pageOptionHeadline ?? ''

    const standards = (data?.standards?.lines?.flatMap((line) => line.entries) ?? [])
        .filter((entry, index, array) => array.findIndex(e => e.id === entry.id) === index)

    const options: GroupedEntries[] = []

    if (data?.exterior?.entries?.length > 0) {
        options.push({
            headline: data?.metadata?.texts?.exteriorHeadline ?? '',
            entries: data?.exterior.entries,
        })
    }
    if (data?.interior?.entries?.length > 0) {
        options.push({
            headline: data?.metadata?.texts?.interiorHeadline ?? '',
            entries: data?.interior?.entries,
        })
    }

    if (data?.options?.lines?.length > 0) {
        options.push({
            headline: optionsHeadline,
            entries: data?.options?.lines?.flatMap((option) => option?.entries.filter((entry) => entry.id)),
        })
    }

    const technicalDataHeadline = data?.metadata?.texts.pageTechnicalDataHeadline ?? ''

    return {
        isLoading,
        modelName: data?.model.name.join(', '),
        standards,
        standardsHeadline,
        options,
        optionsHeadline,
        technicalDataHeadline,
        technicalData: data?.technicalData?.lines ?? [],
        prices: mapPrices(data),
        images: mapImages(data?.media ?? []),
    }
}
